import { useState } from "react";
import { useSelector } from 'react-redux';
import { CloseButton, Col, Modal, Row, Button } from "react-bootstrap";
import { ICONS } from "Utils/icons";
import { TextButton } from "Components/Button";
import { maskEMail } from "Utils/utilityFunctions";

const SelectMFAMethodPopup = ({
  show,
  handleClose,
  showEmailMfa,
  showSmsMfa,
  mfaFactors
}) => {

  const loginInfo = useSelector(state => state.loginInfo);

  // "SMS" or "EMAIL"
  const [activeMethod, setActiveMethod] = useState("");

  const handleSelectMethod = (method) => {
    setActiveMethod(method);
  }

  const cancelMfa = () => {
    setActiveMethod("");
    handleClose();
  }

  const handleNext = (method) => {
    cancelMfa();

    if (method === "SMS") {
      showSmsMfa();
    }

    if (method === "EMAIL") {
      showEmailMfa();
    }
  }
  return (
    <Modal
      id="select-mfa-method-popup"
      className="modal"
      size="md"
      backdrop="static"
      show={show}
      centered
    >
      <Modal.Header className="ps-5 pe-5 pt-5">
        <Modal.Title>
          <CloseButton
            className="closeup-popup-button"
            onClick={cancelMfa}
          >
          </CloseButton>
          <br />
          <h2 className="text-start title">Two-Factor Authentication</h2>
          <h6 className="text-start subtitle mt-3">
            Please select a verification method.
          </h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 ps-5 pe-5">
        {/* mfaStatusSms: 2 : enabled */}
        {mfaFactors.mfaStatusSms === 2 ?
          <>
            <Row>
              <Col className="">
                <Button
                  className={`w-100 ${activeMethod === "SMS" ? 'mfa-method-button-active' : ''}`}
                  onClick={() => handleSelectMethod("SMS")}
                >
                  <div class="mfa-method">
                    <span class="mfa-icon">{ICONS.sms()}</span>
                    <span class="text-start">
                      <span className="mfa-method-title">SMS</span>
                      <br />
                      <span className="mfa-method-desc">Send an SMS code to ***-***-{mfaFactors.smsLast4}</span>
                    </span>
                  </div>
                </Button>
              </Col>
            </Row>
            <hr></hr>
          </> : null}
        {/* mfaStatusEmail: 2 : enabled */}
        {mfaFactors.mfaStatusEmail === 2 ?
          <Row>
            <Col className="">
              <Button
                className={`w-100 ${activeMethod === "EMAIL" ? 'mfa-method-button-active' : ''}`}
                onClick={() => handleSelectMethod("EMAIL")}
              >
                <div class="mfa-method">
                  <span class="mfa-icon">{ICONS.mailoutlined()}</span>
                  <span class="text-start">
                    <span className="mfa-method-title">Email</span>
                    <br />
                    <span className="mfa-method-desc">Send a code via email to {maskEMail(loginInfo.username)}</span>
                  </span>
                </div>
              </Button>
            </Col>
          </Row> : null}
      </Modal.Body>
      <Modal.Footer>
        <Row className="mb-3 pt-1">
          <Col>
            <TextButton
              className="w-10 me-3"
              disabled={activeMethod === ""}
              variant="normal"
              onClick={() => handleNext(activeMethod)}
              content={"Next"}
            >
            </TextButton>
            <TextButton
              className="w-10"
              variant="outline"
              onClick={cancelMfa}
              content={"Cancel"}
            >
            </TextButton>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectMFAMethodPopup;
